module.exports = __webpack_public_path__ + "static/media/jewelry-ring-white.39806595.svg";